enum OrderStatus {
	/** Заказ запчастей */
	PartsOrdering = 1,
	/** Ожидание запчастей */
	PartsAwaiting = 2,	
	/** Согласование визита */
	VisitNegotiating = 3,
	/** Ожидание визита */
	VisitAwaiting = 4,	
	/** Автомобиль принят */
	VehicleAccepted = 5,
	/** Выполнение работ */
	VehicleInProgress = 6,	
	/** Доп. согласование  */
	ExtraNegotiating = 7,	
	/** Работы выполнены */
	VehicleCompleted = 8,
	/** Закрыт */
	Closed = 9,
	/** Отказ */
	Refuse = 10
}

export default OrderStatus